<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :required="required" :rules="normalizedRules">
      <OTableSelect v-model="model" :maxlength="maxlength" :placeholder="placeholder" :disabled="normalizedDisabled"
        :pick="pick" :tag="tag" @change="(attrs.onChange)">
        <slot></slot>
      </OTableSelect>
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { ElCol, ElFormItem } from 'element-plus'
import type { FormTableSelectProps } from './TableSelect'
import OTableSelect from '../../Input/TableSelect/TableSelect.vue'
import { useFormItemSpan, useFormItemRules, useFormItemModel, useFormItemDisabled } from '../hooks'
import { useAttrs } from 'vue'

defineOptions({ name: 'OFormTableselect', inheritAttrs: false })
const attrs = useAttrs()

const { name, label, labelWidth, required, maxlength, placeholder, pick, tag } = defineProps<FormTableSelectProps>()
const normalizedSpan = useFormItemSpan()
const normalizedRules = useFormItemRules()
const normalizedDisabled = useFormItemDisabled()
const model = useFormItemModel()
</script>